import styled from 'styled-components'

export const LogoWrapper = styled.div`
  text-align: center;

  img {
    width: 100%;
    max-width: 500px;
  }

  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.huge};
  `}
`

export const TitleWrapper = styled.div`
  text-align: center;

  ${({ theme }) => `
    padding-bottom: ${theme.space.mobile.large};
    margin-bottom: ${theme.space.mobile.large};
    border-bottom: 1px solid ${theme.color.wartsilaHaze};
  `}
`

export const Content = styled.div`
  ${({ theme }) => `
    p {
      margin-bottom: ${theme.space.mobile.base};
    }

    a {
      color: ${theme.color.oceanLight};
      transition: color .3s ease;

      &:hover {
        color: ${theme.color.ocean};
      }
    }
  `}
`
